<template>
    <div>
        <!-- Single tab -->
        <div class="row table-wrapper">
            <div class="column">
              <vdog-match-table
                  class="d-winner-table"
                  :activeStake="match.activeStake"
                  :title="match.winnerInFirstTable.title"
                  :header="match.winnerInFirstTable.header"
                  :stakes="match.winnerInFirstTable.data"
                  :isBettingEnabled="isBettingEnabled"
                  :sideItems="match.winnerInFirstTable.sideItems"/>
            </div>
            <div class="column">
              <vdog-match-table
                class="combined-table"
                :activeStake="match.activeStake"
                :title="match.combinationBettingTable.title"
                :header="match.combinationBettingTable.header"
                :stakes="match.combinationBettingTable.data"
                :isBettingEnabled="isBettingEnabled"
                :sideItems="match.combinationBettingTable.sideItems"/>
            </div>
        </div>
        <!-- Second row -->
        <div class="row table-wrapper">
            <!-- Left column -->
            <div class="column">
                <vdog-match-table
                    class="double-chance-table"
                    :activeStake="match.activeStake"
                    :title="match.doubleChanceTable.title"
                    :header="match.doubleChanceTable.header"
                    :stakes="match.doubleChanceTable.data"
                    :isBettingEnabled="isBettingEnabled"
                    :sideItems="match.doubleChanceTable.sideItems"/>
                <!-- Second "table" -->
                <div class="banner"></div>
            </div>
            <!-- Right column -->
            <div class="column">
                <vdog-match-trifecta
                    class="trifecta-table"
                    :activeStake="match.activeStake"
                    :title="match.trifectaTable.title"
                    :header="match.trifectaTable.header"
                    :stakes="match.trifectaTable.data"
                    :isBettingEnabled="isBettingEnabled"
                    :stakesData="match.trifectaTable.stakesData"
                    :sideItems="match.trifectaTable.sideItems"/>

                <!-- Small tables -->
                <!-- Sum tables -->
                <div class="row sum-tables">
                    <vdog-match-table
                        class="small-table"
                        :activeStake="match.activeStake"
                        :title="match.sumTable12.title"
                        :header="match.sumTable12.header"
                        :stakes="match.sumTable12.data"
                        :isBettingEnabled="isBettingEnabled"
                        :sideItems="match.sumTable12.sideItems"/>

                    <vdog-match-table
                        class="small-table"
                        :activeStake="match.activeStake"
                        :title="match.sumTable123.title"
                        :header="match.sumTable123.header"
                        :stakes="match.sumTable123.data"
                        :isBettingEnabled="isBettingEnabled"
                        :sideItems="match.sumTable123.sideItems"/>
                </div>
                <!-- Odds tables -->
                <div class="row odds-tables">
                    <vdog-match-table
                        class="small-table"
                        :activeStake="match.activeStake"
                        :title="match.tableLowHigh.title"
                        :header="match.tableLowHigh.header"
                        :stakes="match.tableLowHigh.data"
                        :isBettingEnabled="isBettingEnabled"
                        :sideItems="match.tableLowHigh.sideItems"/>

                    <vdog-match-table
                        class="small-table"
                        :activeStake="match.activeStake"
                        :title="match.tableOddEven.title"
                        :isBettingEnabled="isBettingEnabled"
                        :header="match.tableOddEven.header"
                        :stakes="match.tableOddEven.data"
                        :sideItems="match.tableOddEven.sideItems"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import VDogMatchTable from '@/components/grayhound/match/VDogMatchTable.vue'
import VDogMatchTableTrifecta from '@/components/grayhound/match/VDogMatchTableTrifecta.vue'

export default {
  components: {
    'vdog-match-table': VDogMatchTable,
    'vdog-match-trifecta': VDogMatchTableTrifecta
  },
  props: {
    match: {
      type: Object,
      required: true
    },
    isBettingEnabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VDOG_SELECTED_STAKE, this.selectedItem)
  },
  methods: {
    selectedItem: function (stake) {
      this.match.activeStake = stake
    }
  }
}
</script>
